export default __webpack_public_path__ + "static/media/QSExp.21194923.md";